import React from 'react'
import SettingsPanel from "../components/Settings/SettingsPanel";
import { connect } from 'react-redux';
import { PermissionRole } from "../GlobalConst/globalEnums";

class Settings extends React.Component
{
    render() {
        return(
            <div>
                {
                    this.props.role === PermissionRole.administrator || this.props.role === PermissionRole.owner
                    ? <SettingsPanel/>
                    : 'You have no permissions to access this site'
                }
            </div>
            
        );
    }
}

const mapStateToProps = state => ({
    role: state.user.role
})

export default connect(mapStateToProps, null)(Settings);


// WEBPACK FOOTER //
// ./src/pages/Settings.js